import React from "react"
import cn from "../../../utils/classes"

interface DividerBarProps {
  styleOverrides?: string
}

const DividerBar: React.FC<DividerBarProps> = ({ styleOverrides }) => {
  const defaultStyles = ["h-px", "my-8", "border-0", "bg-gray-700"]
  const className = cn(defaultStyles, styleOverrides)

  return <hr className={className} />
}

export default DividerBar
